<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Tổng hợp thi lại học lại</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu 
                </button>
                <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-file-excel"></i> Xuất excel 
                </button>
                <button class="btn btn-warning btn-sm"  type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>
                  
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Loại tổng hợp</label>
                        <select class="form-control" formControlName="LoaiThongKe">
                            <option value="0">Thi lại</option>
                            <option value="1">Học lại</option>
                            <option value="2">Thi nâng điểm</option>
                            <option value="3">Học cải thiện điểm</option>
                            <option value="4">Học lại LT</option>
                            <option value="5">Học lại TH</option>
                            <option value="6">Thi lại TH</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky" (change)="filterData()">
                            <option value="">Tất cả</option>
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc" (change)="filterData()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lần học</label>
                        <select class="form-control" formControlName="Lan_hoc" (change)="filterData()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let value of [1,2,3,4,5,6,7,8,9,10]" value="{{value}}">{{value}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Mã sv, Họ tên</label>
                        <input class="form-control" formControlName="Ma_sv" (keyup)="filterData()">
                    </div>
                    <div class="col-md-2">
                        <label>Học phần</label>
                        <input class="form-control" formControlName="Hoc_phan" (keyup)="filterData()">
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered" style="width: 100%;">
                    <thead>
                        <tr *ngFor="let i of dataHeader">
                            <th *ngFor="let value of i.Cells" [attr.colspan]="value.Colspan"
                                [attr.rowspan]="value.Rowspan">
                                {{value.Name}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of dataTable">
                            <td *ngFor="let value of i.Value"
                                [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}">
                                {{value.Value}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br>
            <span style="float:right"><b>Tổng số bản ghi</b>: {{recordTotal}}</span>
        </div>
     
    </div>
</section>
